<template lang="pug">
yz-dialog(v-model="showDialog" persistent scrollable max-width="400px")
  yz-card
    yz-dialog-normal-header(title="Daily sales report date" @close="onCancel")
    yz-dialog-normal-content.px-6.py-6
      .yz-medium-body-sm.text-neutral-700.mb-1 Select report date
      yz-menu(v-model="showDatePicker" :close-on-content-click="false" offset-y min-width="auto")
        template(v-slot:activator="{ on, attrs }")
          yz-text-field(v-model="displayDate" v-bind="attrs" v-on="on" size="lg" placeholder="DD/MM/YYYY" readonly clickable hide-details)
            template(v-slot:append)
              v-icon(size="16" color="neutral500") mdi-calendar
        yz-date-picker(v-model="selectedDate" no-title @input="showDatePicker = false")
    yz-dialog-normal-actions(saveLabel="Apply" cancelLabel="Cancel" :disableSave="!selectedDate" @cancel="onCancel" @save="onApply")
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedDate: null,
      showDatePicker: false
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    displayDate () {
      if (!this.selectedDate) return null
      return DateTime.fromISO(this.selectedDate).toFormat('dd/MM/yyyy')
    }
  },
  watch: {
    open (val) {
      if (!val) {
        this.selectedDate = null
        this.showDatePicker = false
      }
    }
  },
  methods: {
    onCancel () {
      this.showDialog = false
    },
    onApply () {
      this.$emit('apply', this.selectedDate)
      this.showDialog = false
    }
  }
}
</script>
